/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {getPaginationDisplayItems} from '../../../../../../../_metronic/helpers'
import {useQueryResponseLoading, useQueryResponsePagination} from '../../core/QueryResponseProvider'
import {useQueryRequest} from '../../core/QueryRequestProvider'

const mappedLabel = (label: string): string => {
  if (label === 'Anterior &laquo;') {
    return 'Anterior'
  }

  if (label === 'Próximo &raquo;') {
    return 'Próximo'
  }

  return label
}

const ListPagination = () => {
  const pagination = useQueryResponsePagination()
  const isLoading = useQueryResponseLoading()
  const {updateState} = useQueryRequest()
  const updatePage = (page: number | null) => {
    if (!page || isLoading || pagination.page === page) {
      return
    }

    updateState({page, items_per_page: pagination.items_per_page || 10})
  }

  const displayItems = getPaginationDisplayItems(pagination.links, pagination.page)

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
      <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
        <div id='kt_table_users_paginate'>
          <ul className='pagination'>
            {displayItems.map((item) => {
              if (item.type === 'ellipsis') {
                return (
                  <li key={item.key} className='page-item disabled'>
                    <span className='page-link'>…</span>
                  </li>
                )
              }
              const link = item.link
              const label = mappedLabel(link.label)
              return (
                <li
                  key={link.label}
                  className={clsx('page-item', {
                    active: pagination.page === link.page,
                    disabled: isLoading,
                    previous: label === 'Anterior',
                    next: label === 'Próximo',
                  })}
                >
                  <a
                    className={clsx('page-link', {
                      'page-text': label === 'Anterior' || label === 'Próximo',
                      'me-5': label === 'Anterior',
                    })}
                    onClick={() => updatePage(link.page)}
                    style={{cursor: 'pointer'}}
                  >
                    {label}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export {ListPagination}
